import { SystemStyleObject } from '@mui/system';
import { bloxValues, fontWeightMedium } from 'themes/constants';

// Add to the sx of StatusText to get a badge/pill look.
export const statusTextBadgeTypography: SystemStyleObject = {
  width: 'max-content',
  textAlign: 'center',
  padding: '2px 8px',
  borderRadius: '4px',
  fontSize: bloxValues.smallFontSizeRem,
  fontWeight: fontWeightMedium,
};

export const searchRowOptionsBtn: SystemStyleObject = {
  padding: 0,
};
